import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useContent } from "@/context/ContentContext";
import { normLang } from "@/i18n";
import { Languages, X } from "lucide-react";

const ACK = "twp_lang_welcomed";

// One-time welcome strip for new visitors: confirms the auto-detected device
// language and lets them switch FR/EN. Dismisses permanently once acknowledged.
export function WelcomeLangBanner() {
  const { t } = useContent();
  const { i18n } = useTranslation();
  const [show, setShow] = useState(() => !localStorage.getItem(ACK));
  if (!show) return null;

  const cur = normLang(i18n.language);
  const ack = () => { localStorage.setItem(ACK, "1"); setShow(false); };
  const pick = (code) => { if (code !== cur) i18n.changeLanguage(code); ack(); };

  return (
    <div data-testid="welcome-lang-banner"
      className="mb-4 flex flex-col gap-2 rounded-2xl border border-accent/30 bg-accent/10 p-3 sm:flex-row sm:items-center sm:justify-between sm:gap-3 sm:p-4">
      <div className="flex items-start gap-3">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-accent/20 text-accent"><Languages className="h-5 w-5" /></span>
        <div className="text-sm">
          <div className="font-semibold text-foreground">{t("welcome.lang.title", "Choisissez votre langue")}</div>
          <div className="hidden text-muted-foreground sm:block">{t("welcome.lang.desc", "Nous avons détecté la langue de votre appareil. Vous pouvez la changer à tout moment.")}</div>
        </div>
      </div>
      <div className="flex items-center gap-2 self-end sm:self-auto">
        <button data-testid="welcome-lang-fr" onClick={() => pick("fr")}
          className={`rounded-full px-4 py-1.5 text-xs font-semibold transition-colors ${cur === "fr" ? "bg-accent text-white" : "border border-border bg-card text-foreground hover:bg-secondary"}`}>Français</button>
        <button data-testid="welcome-lang-en" onClick={() => pick("en")}
          className={`rounded-full px-4 py-1.5 text-xs font-semibold transition-colors ${cur === "en" ? "bg-accent text-white" : "border border-border bg-card text-foreground hover:bg-secondary"}`}>English</button>
        <button data-testid="welcome-lang-dismiss" onClick={ack} aria-label="dismiss"
          className="flex h-8 w-8 items-center justify-center rounded-full text-muted-foreground hover:bg-secondary hover:text-foreground"><X className="h-4 w-4" /></button>
      </div>
    </div>
  );
}
